export const pagination = {
  trucks: { size: 40, page: 0 },
  orders: { size: 40, page: 0 },
  clients: { size: 40, page: 0 },
  drivers: { size: 40, page: 0 },
  clientOrders: { size: 40, page: 0 },
  agents: { size: 40, page: 0 },
  admins: { size: 40, page: 0 },
  sales: { size: 40, page: 0 },
  stock: { size: 40, page: 0 },
  suppliers: { size: 40, page: 0 },
  warehouseItems: { size: 40, page: 0 },
  repairServices: { size: 100, page: 0 },
  preventativeMaintenanceChecklist: { size: 40, page: 0 },
  driverShifts: { size: 40, page: 0 },
  expenses: { size: 40, page: 0 },
  topUps: { size: 40, page: 0 },
  qbSyncLogs: { size: 40, page: 0 }
};

export const MINIMAL_PAGINATION_NUM = 40;
